import { IFlight } from "@vmosolutions/oc-interfaces";
import { Box, Typography } from "@mui/material";
import { FlightChip } from "src/components/Flights/FlightChip";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import moment from "moment-timezone";

interface IOpsLinkFlightRow {
  id: string;
  flight: IFlight;
  styles?: any;
}

const getLocalStart = (flight: IFlight) => {
  return flight?.actualOut && flight?.originAirport?.timezoneId
    ? moment.utc(flight.actualOut).tz(flight.originAirport?.timezoneId)?.format("MMM Do, Y HH:mm z")
    : null;
};

const getLocalEnd = (flight: IFlight) => {
  return flight?.actualIn && flight?.destAirport?.timezoneId
    ? moment.utc(flight.actualIn).tz(flight.destAirport?.timezoneId)?.format("MMM Do, Y HH:mm z")
    : null;
};

export function OpsLinkFlightRow(props: IOpsLinkFlightRow): JSX.Element {
  const { id, flight, styles } = props;
  return (
    <Box sx={{ display: "flex", ...styles }}>
      <FlightChip data={flight} />
      <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "center" }}>
        <Typography variant="body1" sx={{ padding: "3px 5px 0px 5px" }}>
          {getLocalStart(flight)}
        </Typography>
        <ArrowRightAltIcon />
        <Typography variant="body1" sx={{ paddingTop: "3px", paddingLeft: "5px" }}>
          {getLocalEnd(flight)}
        </Typography>
      </Box>
    </Box>
  );
}
